import { useState } from 'react';
import {Link, useLocation} from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import Field from "../components/form/Field";
import {showErrorNotification} from "../util/notifications";
import {routes} from "../routes/routes";
import {ReactComponent as TheVideoGramSVG} from '../../img/thevideogram.svg';
import useApi from "../api";
import useYupValidationResolver from "../util/useYupValidationResolver";
import resetPasswordSchema from "../components/login/validation/resetPasswordSchema";
import classNames from "classnames";
import { getUrlParameter } from '../util/getUrlParameter';

const ResetView = () => {
    const {resetPassword, requestResetPassword} = useApi();
    const [loading, setLoading] = useState(false);
    const [passwordResetted, setPasswordResetted] = useState(false);
    const [message, setMessage] = useState(null);
    const [state, setState] = useState('RESET');
    const location = useLocation();
    const token = getUrlParameter('token');
    const username = getUrlParameter('username');
    const resolver = useYupValidationResolver(resetPasswordSchema);
    const formMethods = useForm({
        resolver,
    });
    const { handleSubmit } = formMethods;

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const response = await resetPassword({
                password: data.password,
                token,
                username,
            });
            if (response.data && response.data.status === 'ok') {
                setMessage(null);
                setState('SUCCESS');
            } else {
                setMessage('Something went wrong. Please try again later.');
            }
        } catch (e) {
            const msg = e.response?.data?.error || 'Something went wrong. Please try again later.';
            if (msg.includes('expired')) {
                setState('EXPIRED');
            } else {
                setMessage(msg);
            }
        }
        setLoading(false);
    }

    const onError = (error) => {
        console.log(error);
        showErrorNotification('Please check the fields.');
    }

    const resetButtonClass = classNames('button', 'button--secondary', {
        'button--loading': loading,
    });

    const onPasswordReset = async (e) => {
        setLoading(true);
        e.preventDefault();
        try {
            await requestResetPassword(username);
            setLoading(false);
            setPasswordResetted(true);
            setMessage('If your account exists, you will receive an email with a reset link.');
        } catch (e) {
            setMessage('Something went wrong. Please try again later.');
        }
    };

    return (
        <div className="login">
            <div className="login__header">
                <TheVideoGramSVG />
            </div>
            <div className="login__box">
                {message ? (
                    <div className="notification notification--inline">{message}</div>
                ) : null}
                {state === 'RESET' ? (
                    <FormProvider {...formMethods} >
                        <form onSubmit={handleSubmit(onSubmit, onError)} noValidate className="form">
                            <Field
                                type="text"
                                name="password"
                                label="Password"
                                placeholder="Password"
                            />
                            <Field
                                type="text"
                                name="repeatPassword"
                                label="Repeat password"
                                placeholder="Repeat password"
                            />
                            <div className="button__bar">
                                <button className={resetButtonClass}>Save</button>
                            </div>
                        </form>
                    </FormProvider>
                ) : state === 'SUCCESS' ? (
                    <>
                        <h3 className="heading heading--md">Password changed successfully</h3>
                        <Link to={routes.login} className="button button--secondary">Log in</Link>
                    </>
                ) : state === 'EXPIRED' ? (
                    <>
                        {passwordResetted ? (
                            <>
                                <Link to={routes.login} className="button button--secondary">Log in</Link>
                            </>
                        ) : (
                            <>
                                <h3 className="heading heading--md">This link has expired</h3>
                                <p>This link has expired. Request a new password reset to receive a new link.</p>
                                <button className={resetButtonClass} onClick={onPasswordReset}>Reset</button>
                                <Link to={routes.login} className="button button--link">Log in</Link>
                            </>
                        )}
                    </>
                ) : null}
            </div>
        </div>
    )
};

export default ResetView;
